import { Controller } from "@hotwired/stimulus"

// Tab strip with panels. `?tab=<name>` (or `#<name>`) in the URL opens that
// tab on load, so other pages can deep-link into a settings section.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const requested = new URLSearchParams(window.location.search).get("tab") || window.location.hash.replace(/^#/, "")
    if (requested && this.tabTargets.some(tab => tab.dataset.tab === requested)) {
      this.activate(requested)
    }
  }

  switch(event) {
    event.preventDefault()
    this.activate(event.currentTarget.dataset.tab)
  }

  activate(selectedTab) {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("tab-active", tab.dataset.tab === selectedTab)
    })
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== selectedTab)
    })
  }
}
